module.exports = __webpack_public_path__ + "img/construction_site.8ca5c334.jpg";